import { Record } from "immutable";

const InitialState = Record({
  apiHost: "",
  siteHost: "",
  clientId: "",
  clientSecret: "",
  sentryUrl: ""
});
const initialState = new InitialState();

export default function configReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.merge(state);
  return state;
}



// WEBPACK FOOTER //
// ./src/common/config/reducer.js